// track-click — 广告点击上报 + 跳转。
// 先尽力 sendBeacon 上报一次点击,再新标签打开外链。上报失败静默,不阻塞跳转。
// 契约:POST /gapi/public/ad/click body { ad_id, slot_type, position }。

export function trackAndOpen(adId: string, slotType: string, position: number, url: string): void {
  try {
    navigator.sendBeacon(
      '/gapi/public/ad/click',
      new Blob([JSON.stringify({ ad_id: adId, slot_type: slotType, position })], {
        type: 'application/json',
      }),
    )
  } catch {
    /* 上报失败静默,不阻塞跳转 */
  }
  window.open(url, '_blank', 'noopener')
}
